export const animationCreate = () => {
  // TODO: Review this code
  // if (typeof window !== "undefined") {
  //   (window as any).WOW = require("wowjs");
  // }
  // new (window as any).WOW.WOW({ live: false }).init();
};

export function wait(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function shuffle(array: any[]): any {
  let currentIndex = array.length;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
}

